<template>
  <div class="flex flex-row gap-1 has-tooltip">
    <a
      href="https://music.amazon.com/podcasts/787a19c5-4874-448d-9c28-3b02703a35a8"
      target="_blank"
    ><img
      src="//summitproedu.imgix.net/redesign-assets/icons/2023/podcast-players/Amazon+Music+Icon.png?w=45&h=45"
      class="mr-3"
    /></a>
    <a
      href="https://podcasts.apple.com/us/podcast/pt-ot-connection-continuing-education-for-therapists/id1692431955"
      target="_blank"
    ><img
      src="//summitproedu.imgix.net/redesign-assets/icons/2023/podcast-players/Apple+Podcast+Icon.png?w=45&h=45"
      class="mr-3"
    /></a>
    <!--    <a href="/"><img src="//summitproedu.imgix.net/redesign-assets/icons/2023/podcast-players/Audible+Icon.png" class="mr-3" /></a> -->
    <a
      href="https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkLnBvZGJlYW4uY29tL3N1bW1pdC1wdC1vdC1jb25uZWN0aW9uL2ZlZWQueG1s"
      target="_blank"
    ><img
      src="//summitproedu.imgix.net/redesign-assets/icons/2023/podcast-players/Google+Podcast+Icon.png?w=45&h=45"
      class="mr-3"
    /></a>
    <!--    <a href="/"><img src="//summitproedu.imgix.net/redesign-assets/icons/2023/podcast-players/Pandora+Icon.png" class="mr-3" /></a> -->
    <!--    <a href="/"><img src="//summitproedu.imgix.net/redesign-assets/icons/2023/podcast-players/Podcast+Addict+Icon.png" class="mr-3" /></a> -->
    <a
      href="https://open.spotify.com/show/0QY3ahLFZkI65F4nrPVViX"
      target="_blank"
    ><img
      src="//summitproedu.imgix.net/redesign-assets/icons/2023/podcast-players/Spotify+Icon.png?w=45&h=45"
      class="mr-3"
    /></a>
    <a
      href="https://iheart.com/podcast/117238753"
      target="_blank"
    ><img
      src="//summitproedu.imgix.net/redesign-assets/icons/2023/podcast-players/iHeart+Icon.png?w=45&h=45"
      class="mr-3"
    /></a>
    <!--    <a href="/"><img src="//summitproedu.imgix.net/redesign-assets/icons/2023/podcast-players/Stitcher+Icon.png" class="mr-3" /></a> -->
    <a
      href="https://tunein.com/podcasts/Education-Podcasts/PT--OT-Connection-Continuing-Education-for-Thera-p3746558/"
      target="_blank"
    ><img
      src="//summitproedu.imgix.net/redesign-assets/icons/2023/podcast-players/Tune+In+Icon.png?w=45&h=45"
      class="mr-3"
    /></a>
  </div>
</template>

<script>
export default {
  name: 'PodcastSocialIcons',
};
</script>
